import './assets/css/app.css';

import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import DisplayPdf from './components/DisplayPdf';
import Navbar from './components/Navbar';
//import Sidebar from './components/Sidebar';
import WaitingForTx from './components/WaitingForTx';
import Create from './pages/Create';
import Details from './pages/Details';
//import Home from './pages/Home';
import Login from './pages/Login';
import Profile from './pages/Profile';
import { NftContext } from './providers/NftProvider';

const App = () => {
  const nftInfos = useContext(NftContext);

  return (
    <Router basename={'/'}>
      <Navbar />
      {nftInfos.waitForTx.message && <WaitingForTx content={nftInfos.waitForTx} />}
      <Switch>
        <Route path="/seePdf">
          <DisplayPdf />
        </Route>
        <Route path="/details">
          <Details />
        </Route>
        <>
          <div className="wrapper">
            {/* <Sidebar /> */}
            <Route exact path="/">
              <Profile />
            </Route>
            <Route path="/create">
              <Create />
            </Route>

            <Route path="/login">
              <Login />
            </Route>
            <Route path="/profile">
              <Profile />
            </Route>
          </div>
        </>
      </Switch>
      <p className="text-center wrapper">
        <a target="_blank" rel="noreferrer" className="footertxt" href="https://ato.network/">
          ĀTO Website
        </a>
      </p>
    </Router>
  );
};

export default App;

/* const PrivateRoute = (Component, selectedAddress) => (props) =>
  selectedAddress ? <Route {...props} component={Component} /> : <Redirect to="/login" />;
const PublicRoute = (Component, selectedAddress) => (props) =>
  !selectedAddress ? <Route {...props} component={Component} /> : <Redirect to="/login" />;
 */
